import { render, staticRenderFns } from "./unsubscribe.html?vue&type=template&id=f977e3c4&scoped=true&external"
import script from "./unsubscribe.js?vue&type=script&lang=js&external"
export * from "./unsubscribe.js?vue&type=script&lang=js&external"
import style0 from "./unsubscribe.scss?vue&type=style&index=0&id=f977e3c4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f977e3c4",
  null
  
)

export default component.exports